var path = 'src/app/patients/nurture-data/nurture-data.html';
var html = "<h1 class=page-header>Nurture Data</h1> <div patient-nurture-data-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/nurture-data/nurture-data.html
 ** module id = 524
 ** module chunks = 0
 **/